<template>
  <div class="partners-page">
    <site-header />

    <main>
      <div class="page-title">
        <span>OUR PARTNERS</span>
        <h1>合作伙伴</h1>
        <p>携手高校、科研院所与医疗机构，为专业用户提供高效可靠的翻译服务</p>
      </div>
      <div class="partners-grid">
        <article v-for="partner in partners" :key="partner.name" class="partner-card">
          <img :src="partner.logo" :alt="partner.name">
          <h2>{{ partner.name }}</h2>
        </article>
      </div>
    </main>

    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'

export default {
  name: 'Partners',
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      partners: [
        { name: '中国石化北京化工研究院', logo: require('@/assets/img/p__石化.png') },
        { name: '首都医科大学宣武医院', logo: require('@/assets/img/p__宣武.png') },
        { name: '华北电力大学（保定）', logo: require('@/assets/img/p__华北电力.png') },
        { name: '北京市农林科学院', logo: require('@/assets/img/p__农林.png') },
        { name: '辽宁省农业科学院', logo: require('@/assets/img/p__辽宁.png') },
        { name: '河北工程技术学院', logo: require('@/assets/img/p__河北工程.png') },
        { name: '北京舞蹈学院', logo: require('@/assets/img/wd.png') },
        { name: '宁夏农林科学院', logo: require('@/assets/img/p__宁夏.png') },
        { name: '中国医科大学', logo: require('@/assets/img/p__中国医科大学.png') },
        { name: '北京妇产医院', logo: require('@/assets/img/p__妇幼.png') },
        { name: '北京友谊医院', logo: require('@/assets/img/p__北京友谊.png') },
        { name: '四川大学华西医院', logo: require('@/assets/img/p__四川大学.png') }
      ]
    }
  }
}
</script>

<style scoped>
.partners-page {
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #1a1a2e;
  background: #f3f7fb;
  font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
}

main {
  width: 100%;
  min-width: 0;
  min-height: calc(100vh - 128px);
  flex: 1;
  padding: 54px 24px 72px;
  box-sizing: border-box;
  background: radial-gradient(circle at 85% 5%, var(--primary-alpha-08), transparent 30%),
    linear-gradient(180deg, var(--primary-alpha-08), var(--primary-alpha-08));
}

.page-title {
  width: 100%;
  max-width: none;
  margin: 0 0 38px;
}

.page-title span {
  color: var(--primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
}

.page-title h1 {
  margin: 8px 0 12px;
  color: var(--primary-dark);
  font-size: 36px;
}

.page-title p {
  margin: 0;
  color: #617285;
  font-size: 14px;
  line-height: 1.7;
}

.partners-grid {
  width: 100%;
  max-width: none;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.partner-card {
  min-width: 0;
  height: 150px;
  padding: 22px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dbe5ef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, .06);
}

.partner-card img {
  width: 100%;
  height: 65px;
  object-fit: contain;
}

.partner-card h2 {
  width: 100%;
  min-width: 0;
  margin: 12px 0 0;
  overflow: hidden;
  color: #5d6772;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 769px) and (max-width: 1100px) {
  main {
    padding: 42px 24px 60px;
  }

  .partners-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }
}

@media (max-width: 768px) {
  main {
    min-height: calc(100vh - 56px);
    padding: 34px 20px 48px;
  }

  .page-title {
    margin-bottom: 28px;
  }

  .page-title h1 {
    margin-top: 6px;
    font-size: 30px;
  }

  .partners-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .partner-card {
    height: 128px;
    padding: 14px;
  }

  .partner-card img {
    height: 52px;
  }
}

@media (max-width: 480px) {
  main {
    padding: 28px 16px 40px;
  }

  .page-title h1 {
    font-size: 28px;
  }

  .partners-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .partner-card {
    height: 116px;
    padding: 14px 18px;
  }

  .partner-card h2 {
    overflow: visible;
    line-height: 1.45;
    text-overflow: clip;
    white-space: normal;
  }
}
</style>
